module.exports = __webpack_public_path__ + "assets/img/soft4.f5eb57fd.jpg";